// extracted by mini-css-extract-plugin
export default {"cls1":"Tooltip-cls1___239325969fe6515b9bf","cls2":"Tooltip-cls2___77be066943fea23c4da Tooltip-cls1___239325969fe6515b9bf"};